export const THRESHOLDS = {
  MIN_AVAILABLE_HEIGHT: 0,
  MIN_WIDGET_COUNT: 0,
  SINGLE_WIDGET: 1,
  EMPTY_COUNT: 0,
} as const;
